<template>
  <div fluid class="d-flex flex-column py-4" :class="{ 'justify-center': mobile }"
    :style="{ 'height': mobile ? '70px' : '90px' }">
    <div class="d-flex align-center">

      <div v-show="false">
        <audio controls class="player"></audio>
      </div>

      <div class="d-flex align-center justify-center player-icon-container mx-2"
        :style="{ width: !mobile ? '70px' : '40px' }">

        <svg v-if="!isPlaying && !isLoading" @click="playFunction()" xmlns="http://www.w3.org/2000/svg" width="53"
          height="55" viewBox="0 0 53 55" fill="none">
          <path d="M0.599998 0.384852L52.7831 27.5L0.599996 54.6151L0.599998 0.384852Z" fill="#C4C4C4" stroke="black"
            stroke-width="0.2" />
        </svg>

        <svg v-if="isPlaying && !isLoading" @click="pauseFunction()" xmlns="http://www.w3.org/2000/svg" width="26"
          height="40" viewBox="0 0 26 40" fill="none">
          <path d="M16 39V1H25V39H16Z" fill="#C4C4C4" stroke="black" stroke-width="0.1" />
          <path d="M1 39V1H10V39H1Z" fill="#C4C4C4" stroke="black" stroke-width="0.1" />
        </svg>

        <div v-if="isLoading" class="d-flex w-100 h-100 justify-center align-center"> <v-progress-circular :size="35"
            color="white" indeterminate></v-progress-circular>
        </div>
      </div>

      <div class="d-flex font-avenir align-center pl-2 marquee-container"
        :class="{ 'marquee-mobile-container': mobile }">
        <div v-if="this.metaData" class="">
          <marquee-text
            :duration="!mobile ? this.metaData.length / 5 + 50 : this.metaData.length / 5 + 15"
            :repeat="10" :key="this.metaData">
            <p :style="{ marginRight: !mobile ? '400px' : '100px' }" v-html="this.metaData"></p>
          </marquee-text>
        </div>
      </div>
      <!-- menu icon for mobile -->
      <div class="pa-0 menu-icon hidden-md-and-up ml-2" @click="mobileMenuOpen()"
        style="width: 80px; height:60px; cursor: pointer;">
        <img :src="require('@/assets/open.png')" v-show="this.mobileMenuStatus" />
        <img :src="require('@/assets/close.png')" v-show="!this.mobileMenuStatus" />
        <!-- {{ this.mobileMenuStatus }} -->
      </div>

    </div>

    <div no-gutters class="px-8 mt-2 hidden-sm-and-down">
      <VolumeControlView :volumeLevel="this.volumeLevel"></VolumeControlView>
    </div>

  </div>
</template>

<script>
import Plyr from "plyr";
import MarqueeText from "vue-marquee-text-component";
import VolumeControlView from "@/views/VolumeControlView.vue";
import { io } from "socket.io-client";

export default {
  components: {
    MarqueeText,
    VolumeControlView
  },
  props: ['volumeLevel'],
  data() {
    return {
      player: null,
      isPlaying: false,
      isLoading: false,
      volumeValue: 0.8,
      metaData: null,
      mute: false,
      socket: null,
      mobileMenuStatus: false,
    };
  },
  inject: ["eventBus", 'mobile'],
  async created() {

    this.socket = io("wss://oolongradio.com:8443");
    // this.socket = io("http://127.0.0.1:8081");
    this.socket.on("connect", () => {
      console.log("socket connect to: ", this.socket.id)
    })

    this.socket.on("connect_error", (err) => {
      console.log(err)
    })

    this.eventBus.on('volume-value', (value) => {

      let mappedValue = this.scale(value, 0, 218, 0, 1).toFixed(1)
      this.player.volume = mappedValue;
    })

    this.eventBus.on('close-mobile-menu', () => {
      this.mobileMenuStatus = false
    })

    this.getInitialMetadata(); // loading metadata when the page is first loaded.
  },
  mounted() {

    //receive socket message from server then push the metadata to this.metaData
    this.socket.on("metadata", (data) => {
      var meta = data.substring(
        data.indexOf("StreamTitle='") + 13,
        data.indexOf("';")
      );
      this.metaData = meta
    });

    this.player = new Plyr(".player"); //.player is defined on <audio></audio>


    this.player.on("play", () => {
      this.isLoading = true;
    });

    this.player.on("playing", () => {
      this.isPlaying = true;
      this.isLoading = false;
    });

    this.player.on("pause", () => {
      this.isPlaying = false;
      this.player.source = {
        type: "audio",
        sources: [
          {
            src: "",
            type: "audio/mp3",
          },
        ],
      };
    });

    this.player.on('volumechange', () => {
    
      // this.vvv = this.player.volume
      // this.player.volume = 0.1
    })

  },
  beforeUnmount() {
    this.socket.disconnect();
    this.player.destroy();
  },
  watch: {
    mobileMenuStatus(newVal) {
      this.eventBus.emit('mobile-menu-open', newVal)
    }
  },
  methods: {
    scale(number, inMin, inMax, outMin, outMax) {
      return (number - inMin) * (outMax - outMin) / (inMax - inMin) + outMin
    },
    async getInitialMetadata() {
      const response = await fetch(
        "https://stream.oolongradio.com:8443/status-json.xsl"
      );
      const data = await response.json();

      //check if source is more than one e.g. [stream, live]
      let moreThanOneSource = Array.isArray(await data.icestats.source)

      if (!moreThanOneSource) { //if there is only one source, get the initial metadata from the single source 
        this.metaData = data.icestats.source.title
      }
      else { // more than one sources
        if (data.icestats.source[0].stream_start)
          this.metaData = data.icestats.source[0].title
        else
          this.metaData = data.icestats.source[1].title
      }
    },
    playFunction() {
      this.player.source = {
        type: "audio",
        sources: [
          {
            src: "https://stream.oolongradio.com:8443/live",
            type: "audio/mp3",
          },
        ],
      };
      this.player.play();
    },
    pauseFunction() {
      this.player.stop();
    },

    muteFunction(value) {
      this.mute = value;
      this.player.muted = (value) ? true : false
    },

    mobileMenuOpen() {
      this.mobileMenuStatus = !this.mobileMenuStatus

    }
  }
}
</script>

<style scoped>
.menu-icon img {
  /* width: 100%; */
  height: 100%;
}

.player-icon-container {
  cursor: pointer;
  height: 50px;
}

.marquee-container {
  font-size: 25px;
  width: 100%;
  overflow: hidden
}

.marquee-mobile-container {
  font-size: 20px;
}

.gardient-background {
  background: linear-gradient(325deg, #9d4700, #b3d400);
  background-size: 400% 400%;
  animation: gradient 10s ease infinite;
}

.invert {
  filter: invert(100%);
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}
</style>
